import { useState } from "react";

export const useIsInfoOpen = () => {
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  return {
    isInfoOpen,
    setIsInfoOpen,
  };
};
